import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_LIST } from '../constants';
import { apiProvider } from '../api';

const filter = {
	PrInvoiceNo: null as null | string,
	PrPartReturnStatusId: null as string | null,
};

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_LIST,
	dropdownList: {
		PrPartReturnStatusId: [],
	},
	filter,
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
